import { IBadge } from "@faire/web-api/indigofair/badges/IBadge";
import { IBadgeStyle } from "@faire/web-api/indigofair/badges/IBadgeStyle";
import sortBy from "lodash/sortBy";

/**
 * Picks the most appropriate badge to display from a list of badges, based of
 * their priorities and positions.
 */
export const selectBadge = (
  badges: IBadge[],
  position: IBadgeStyle["position"]
): IBadge | undefined => {
  const sortedValidBadges = sortBy(
    badges?.filter(
      (badge) =>
        badge.display_to_user &&
        badge.style?.badge_message &&
        (!position || position === badge.style?.position)
    ),
    (b) => -(b.priority ?? 0)
  );

  return sortedValidBadges[0];
};
